import Immutable from 'immutable';

export const actionTypes = {
  ANONYMIZE_PROFILES: 'edrolo/anonymizer/ANONYMIZE_PROFILES',
  DEANONYMIZE_PROFILES: 'edrolo/anonymizer/DEANONYMIZE_PROFILES',
};

const defaultState = Immutable.Map({
  anonymizeProfiles: false,
});

// Main Reducer export
export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actionTypes.DEANONYMIZE_PROFILES:
      return state.set('anonymizeProfiles', false);

    case actionTypes.ANONYMIZE_PROFILES:
      return state.set('anonymizeProfiles', true);

    default:
      return state;
  }
};
